import React from 'react';
import { BrainIcon, GlobeIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t-2 border-celeste/40 bg-white px-4 py-12 pb-24 md:pb-12" data-id="element-218" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-4xl text-center" data-id="element-219" data-mp="32oe2m2kq2nec">
        <p className="inline-flex items-center gap-2 font-display text-xl text-primary" data-id="element-220" data-mp="32pp3nums9h1r">
          <BrainIcon className="h-5 w-5 text-accent" data-id="element-221" data-mp="36pzebklisvmy" /> COMPRADIGITALYA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-222" data-mp="3ugbsveb9tqmi">
          El sistema N°1 para Acompañantes Terapéuticos en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-223" data-mp="36d2ywbrgrms">
          Porque acompañar a alguien en su vida cotidiana merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-224" data-mp="3qc3zv4xs5oih">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="mailto:compradigitalyaa@gmail.com" data-id="element-225" data-mp="2a1jjpa3jzw2z">
            <MailIcon className="h-4 w-4" data-id="element-226" data-mp="3la27uq37evt4" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-227" data-mp="3gbqzykwgyvdj">
            <GlobeIcon className="h-4 w-4" data-id="element-228" data-mp="3qapwx67vh2kp" /> www.compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-celeste/40 pt-6 text-xs font-medium text-slate-400" data-id="element-229" data-mp="80xhs2coepgg">
          © CompraDigitalYa™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}